<template>
	<div>
		<h1>Environnements</h1>

		<b-table striped hover :items="envs" :fields="fields">
			<template v-slot:cell(uid)="data">
				<router-link :to="{ name: 'env', params: { id: data.value } }"
					><i class="fas fa-edit"></i
				></router-link>
			</template>
		</b-table>

		<b-button @click="newEnv()">Nouvel environnement</b-button>
	</div>
</template>

<script>
	import { uuid } from "vue-uuid";

	import store from "../store";
	import users from "../services/users.js";

	export default {
		name: "envs",
		data() {
			return {
				envs: [],
				fields: [
					{
						key: "name",
						label: "Nom",
						sortable: true,
					},
					{
						key: "uid",
						label: "",
					},
				],
			};
		},
		methods: {
			newEnv() {
				this.$router.push({
					name: "env",
					params: { id: this.$uuid.v4() },
				});
			},
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.env) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			if (!this.client.details) this.client.details = {};

			if (!this.client.details.env) this.client.details.env = {};

			this.env = [];
			var keys = Object.keys(this.client.details.env);
			for (var i = 0; i < keys.length; i++) {
				this.envs.push({
					name: this.client.details.env[keys[i]].name,
					uid: keys[i],
				});
			}
		},
	};
</script>

<style></style>
